import React from 'react';
import PropTypes from 'prop-types';
import { IconText } from 'web-ui-components/lib/molecules/icon-text';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandardBody } from 'web-ui-components/lib/typography/body';

const renderWarningMessage = (unAuthorisedMsg) => (
	<IconText iconType="AuthorisationLarge" iconSize="28" iconColor="warn" iconBackingSize="md" layout="left">
		<p className="u-margin-bottom-0">{unAuthorisedMsg}</p>
	</IconText>
);

const PaymentHeader = ({
	hasPaymentCapability,
	showSubHeader,
	content,
	batchName,
	isBatchEdit,
	isPaymentEdit,
	templateMode,
	templateId,
	chapsMode,
}) => {
	const getHeader = () => {
		if (templateMode && templateId) return content.editTemplateHeader;
		if (templateMode) return content.templateHeader;
		if (isBatchEdit) return `${content.editBatchHeader} ${batchName}`;
		if (isPaymentEdit) return content.editPaymentHeader;
		if (chapsMode) return content.makeChapsPaymentHeader;
		return content.header;
	};

	const getHeaderSubText = () => {
		if (templateMode) return content.templateSubText;
		if (templateId) return content.templatePaymentSubText;
		if (hasPaymentCapability && showSubHeader) return content.subHeader;
		if (isBatchEdit) return content.editBatchSubtext;
		return null;
	};

	const headerSubtext = getHeaderSubText();

	return (
		<div>
			<PageHeading data-test-id="payment-header">{getHeader()}</PageHeading>
			{headerSubtext && (
				<StandardBody>
					<p>{headerSubtext}</p>
				</StandardBody>
			)}
			{chapsMode && (
				<StandardBody>
					<p>{content.chapsSubHeader}</p>
				</StandardBody>
			)}
			{!hasPaymentCapability && renderWarningMessage(content.unAuthorisedMsg)}
		</div>
	);
};

PaymentHeader.propTypes = {
	hasPaymentCapability: PropTypes.bool,
	showSubHeader: PropTypes.bool,
	content: PropTypes.shape({
		header: PropTypes.string,
		subHeader: PropTypes.string,
		unAuthorisedMsg: PropTypes.string,
		editBatchHeader: PropTypes.string,
		editPaymentHeader: PropTypes.string,
		editBatchSubtext: PropTypes.string,
		makeChapsPaymentHeader: PropTypes.string,
	}).isRequired,
	isBatchEdit: PropTypes.bool,
	isPaymentEdit: PropTypes.bool,
	batchName: PropTypes.string,
	templateMode: PropTypes.bool,
	templateId: PropTypes.string,
	chapsMode: PropTypes.bool,
};

export default PaymentHeader;
